export default {
    description: "描述",
    orderingNote: "订购须知"
}